function init() {
    InitHomeIntro();
}
function InitHomeIntro() {
    var homeHero = document.querySelector('.js-hero-img');

    if (homeHero && window.innerWidth > 1023) {
        var defaultImg = $('.js-hero-img').attr('src');

        $('.js-card').on('mouseenter', function () {
            var imgSrc = $(this).data('img');
            $('.js-hero-img').attr('src', imgSrc);
        })
        $('.js-card').on('mouseleave', function () {
            $('.js-hero-img').attr('src', defaultImg);
        })
    }
    if (homeHero && $('html').hasClass('toolkit-nds')) {
        $('.js-card').each(function () {
            var href = $(this).find('.link-cta').attr('href');
            if (href) {
                $(this).addClass('js-card--clickable').data('href', href);
            }
        });

        $('.js-card--clickable').on('click', function (e) {
            if ($(e.target).closest('a, button').length) return;
            var href = $(this).data('href');
            if (href) window.location.href = href;
        });
    }
    if (homeHero) {
        // console.log('home hero')
        const links = $('.js-overlay-content').find('a');
        links.each((index, link) => $(link).attr("tabindex", '-1'));
        const defaultLinks = $('.hero__content-load').find('a');
        const buttons = $('[data-controls]');
        const tnsItems = $('.tns-item').find('a');
        $('.js-overlay-close').attr('tabindex', '-1');

        $('.js-overlay').on('click', function () {
            $('.js-overlay-content').addClass('open');
            links.each((index, link) => $(link).attr("tabindex", '0'));
            defaultLinks.each((index, link) => $(link).attr("tabindex", '-1'));
            buttons.each((index, button) => $(button).attr("tabindex", '0'));
            tnsItems.each((index, item) => $(item).attr("tabindex", '0'));
            $('.js-overlay-close').attr('tabindex', '0');
        })
        $('.js-overlay-close').on('click', function () {
            $('.js-overlay-content').removeClass('open');
            defaultLinks.each((index, link) => $(link).attr("tabindex", '0'));
            buttons.each((index, button) => $(button).attr("tabindex", '-1'));
            tnsItems.each((index, item) => $(item).attr("tabindex", '-1'));
            $('.js-overlay-close').attr('tabindex', '-1');
        })
    }
}
export {
    init
}